import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";
import defaultErrorHandler from "actions/global/default-error-handler";

import {
  MODULE_LOADING,
  MODULE_ADD,
  MODULE_UPDATE,
  MODULE_DELETE,
  MODULE_LIST
} from "./types";
import { requestCommonSearch } from "../common/requests";

const localeUrl = `${settings.localeUrl}api/`;
const ENDPOINT = "module";

export const setLoading = (status) => ({
  type: MODULE_LOADING,
  payload: status
});

export const moduleAdd = (data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}`, data)
    .then(response => {
      dispatch({
        type: MODULE_ADD,
        payload: response.data
      });
      callback(true);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const moduleUpdate = (id, data, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}/${id}`, data)
    .then(response => {
      dispatch({
        type: MODULE_UPDATE,
        payload: response.data
      });
      callback(true);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const moduleDelete = (id) => dispatch => {
  dispatch(setLoading(true));
  axios
    .delete(`${localeUrl}${ENDPOINT}/${id}`)
    .then(() => {
      dispatch({
        type: MODULE_DELETE,
        payload: {
          id
        }
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const moduleGetList = (criteria = []) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}/list`, {
      criteria
    })
    .then(response => {
      dispatch({
        type: MODULE_LIST,
        payload: response.data.content
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const moduleGetSearch = (
  pageNumber = 0,
  pageSize = 10,
  sort = "id,ASC",
  criteria = [],
) => dispatch => {
  dispatch(setLoading(true));
  requestCommonSearch(ENDPOINT, pageNumber, pageSize, sort, criteria, localeUrl)
    .then(response => {
      dispatch({
        type: MODULE_LIST,
        payload: response
      });
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};

export const moduleGetSingle = (id, callback) => dispatch => {
  dispatch(setLoading(true));
  axios
    .post(`${localeUrl}${ENDPOINT}/search?page=0&size=1`, {
      criteria: [{
        fieldName: "id",
        fieldValue: id,
        searchOperation: filterTypes.EQUALS.value
      }]
    })
    .then(response => {
      dispatch(setLoading(false));
      let res = false;
      if (response && response.data && response.data.content && response.data.content[0]) {
        res = response.data.content[0];
      }
      callback(res);
    })
    .catch(err => {
      dispatch(setLoading(false));
      defaultErrorHandler(err);
    });
};



// WEBPACK FOOTER //
// ./src/actions/module/requests.js